import { render } from "./popBg.vue?vue&type=template&id=5ab86c18&scoped=true"
import script from "./popBg.vue?vue&type=script&lang=js"
export * from "./popBg.vue?vue&type=script&lang=js"

import "./popBg.vue?vue&type=style&index=0&id=5ab86c18&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab86c18"]])

export default __exports__